<template>
    <section class="stops-list-stack">
        <div class="container">
            <header class="component-header">
                <h2 class="subhead-2">{{ title }}</h2>
            </header>

            <ul class="stack">
                <li v-for="item in items" :key="item.id">
                    <CardsSite v-if="dataType === 'site'" type="list" :item="item" />
                    <CardsGenericTrail v-else type="list" :item="item" />
                </li>
            </ul>
        </div>
    </section>
</template>

<script setup>
    const props = defineProps({
        items: {
            type: Array,
            required: true,
            default: [],
        },
        dataType: {
            type: String,
            required: false,
            default: 'site',
        },
    });

    const { items, dataType } = toRefs(props);

    const total = computed(() => {
        return items.value.length || 0;
    });

    const title = computed(() => {
        if (dataType.value === 'generic') {
            return `Stops on this itinerary (${total.value})`;
        } else {
            return `Sites on this itinerary (${total.value})`;
        }
    });
</script>

<style lang="scss" scoped>
    .stops-list-stack {
        padding: 30px 0;

        // Nothing below it on the page, so its bottom padding just stacked on
        // top of the spacing the footer block already provides. Only when it is
        // genuinely last — an itinerary that ends with another block still
        // needs the separation.
        &:last-child {
            padding-bottom: 0;
        }

        @media (min-width: $tablet) {
            .stack {
                display: grid;
                grid-template-columns: repeat(4, 1fr);
                grid-gap: 20px;
            }

            li {
                margin-bottom: 20px;
            }

            .card-trail {
                flex-direction: column;
                height: 100%;
            }
        }
    }
</style>
